export default __webpack_public_path__ + "static/media/Help.8e845978.svg";